import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { TreeSignal } from '@xanadu/signal';

@Component({
    selector: 'app-common-meta',
    templateUrl: './common-meta.component.html',
    styleUrls: ['./common-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('common-meta')
export class CommonMetaComponent {
    private readonly treeSignal = inject(TreeSignal);

    model = input<any>();

    metaName: any = { id: 'name', name: 'Name', readonly: true };
    metaInput: any = {
        id: '_id',
        name: 'Input',
        value: '_id',
        label: 'name'
    };

    public listMode: boolean = false;

    constructor() {

        effect(() => {
            const model = this.model();

            if (model) {
                if (model.meta?.inputs) {
                    this.metaInput.options = model.meta.inputs;
                }

                if (model.type?.inputId && !model.type?.isNew) {
                    this.metaInput.readonly = true;
                }
            }
        });
    }

    public onInput(event: any) {
        this.treeSignal.input.set(event);
    }

    public onToggleList(event: boolean) {
        this.listMode = event;
    }
}
